"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoringFactorMap = exports.ScoringFactor = void 0;
const targetGroup_1 = require("./targetGroup");
var ScoringFactor;
(function (ScoringFactor) {
    ScoringFactor["MaleShare"] = "maleShare";
    ScoringFactor["FemaleShare"] = "femaleShare";
    ScoringFactor["CoupleShare"] = "coupleShare";
})(ScoringFactor = exports.ScoringFactor || (exports.ScoringFactor = {}));
exports.ScoringFactorMap = {
    [targetGroup_1.TargetGroup.Male]: ScoringFactor.MaleShare,
    [targetGroup_1.TargetGroup.Female]: ScoringFactor.FemaleShare,
    [targetGroup_1.TargetGroup.Couple]: ScoringFactor.CoupleShare,
};
//# sourceMappingURL=scoringFactor.js.map